function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.4998,
  cy: 40,
  r: 33.3333,
  fill: "#28A745"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7215 30.974L55.6207 27.8731C55.054 27.3029 54.1248 27.3029 53.5581 27.8731L34.9761 46.4552L26.1364 37.5487C25.5662 36.9803 24.6441 36.9803 24.0704 37.5487L20.973 40.6478C20.4029 41.2144 20.4029 42.1454 20.973 42.7156L30.8035 52.6164L30.8316 52.6604L32.9769 54.8056L33.4749 55.3002L33.9325 55.7612C34.4991 56.3244 35.4283 56.3244 35.9985 55.7612L58.7215 33.0382C59.2917 32.4698 59.2917 31.5424 58.7215 30.974Z",
  fill: "white"
});

function SvgSuccessCheckmark(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmark);
export default __webpack_public_path__ + "static/media/success-checkmark.c87c41dd.svg";
export { ForwardRef as ReactComponent };